module.exports = __webpack_public_path__ + "img/img_out_offering_fixed_in2019.5c9fb004.png";